import { matchPath } from 'react-router';
import type { match } from 'react-router';
import type { RouterState } from 'redux-first-history';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface Options {
  selectRouterState?: (state: RootState) => RouterState;
  routerReducerKey?: string;
  path: string | string[];
  exact?: boolean;
}

export const createMatchSelector = (options: Options) => {
    let lastPathname: string | null = null;
    let lastMatch: match<Record<string, string>> | null = null;

    let {
        selectRouterState, exact = false, path,
    } = options ?? {};

    if (typeof selectRouterState !== 'function') {
        selectRouterState = (state: RootState): RouterState => state.router;
    }

    return (state: RootState): match<Record<string, string>> | null => {
        const routerState = selectRouterState(state);
        const pathname = routerState?.location?.pathname ?? '';

        if (pathname === lastPathname) {
            return lastMatch;
        }

        lastPathname = pathname;
        const match = matchPath(pathname, { path, exact });

        if (!match || !lastMatch || (match.url !== lastMatch.url) || (match.isExact !== lastMatch.isExact)) {
            lastMatch = match;
        }

        return lastMatch;
    };
};

const routerState = (state: RootState) => state.router;

export const getLocation = createSelector(
    routerState,
    (router) => router.location,
);